import styled from 'styled-components'

export const CardHeader = styled.span`
	align-items: flex-start;
	display: flex;
	justify-content: space-between;
`
